import React, { Component } from 'react';
import PhoneIcon            from 'assets/icons/Phone-white.png';
import EmailIcon            from 'assets/icons/Email-white.png';

export class Contact extends Component {
  render() {
    return (
      <div id="main-content-target">
          <h1 className="text-danger">Contact Us</h1>

          <div className="">
            <div className="d-flex align-items-center mb-2">
              <img src={ PhoneIcon } className="bg-grey p-1 w-em-5 mr-2 rounded" alt="contact-phone" />
              <span>1300 88 2362</span>
            </div>

            <div className="d-flex align-items-center mb-2">
              <img src={ EmailIcon } className="bg-grey p-1 w-em-5 mr-2 rounded" alt="contact-email" />
              <span>care@bookdoc.com</span>
            </div>
          </div>
      </div>
    );
  }
}